export default "__VITE_ASSET__CpEDaHoS__"